module.exports = __webpack_public_path__ + "img/drh5_language_en.a09915dd.png";